import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c9cc3904"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleSubHeader: require('/app/app/components/article/SubHeader/index.vue').default,ArticleHeader: require('/app/app/components/article/Header/index.vue').default,AdvBanner: require('/app/app/components/adv/Banner/index.vue').default,WidgetScrollProgress: require('/app/app/components/widget/ScrollProgress/index.vue').default})
